module.exports = __webpack_public_path__ + "static/media/mobile-menu.8608ac63.svg";